export const GoogleMapApiConfig = "AIzaSyAofB_P0jWMSUsuv20R0YlNNgKjALfjN9A";
